// Copyright (c) 2025 DTCC and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { RejectedBurn } from '@daml.js/dtc-registry-app/lib/Dtc/Registry/App/V3/Model/Burn';
import { TemplateHistory, useTemplateHistory } from '../../useTemplateHistory';

export const useRejectedBurns2Step = (): TemplateHistory<RejectedBurn> =>
  useTemplateHistory(RejectedBurn);
